
import HeroAreaInternal from '@/components/modules/HeroAreaInternal'
export default {
    components: {
        HeroAreaInternal
    },
    head() {
        return {
            title: "Local MOT Guide",
            meta: [
                {
                    hid: 'og:title',
                    property: 'og:title',
                    content: "Local MOT Guide"
                },
                {
                    hid: 'twitter:title',
                    property: 'twitter:title',
                    content: "Local MOT Guide"
                },
            ],
        }
    },
    layout: 'internal-hero'
}
